/**
 * Apply the data attribute `data-sticky-tracking="true"` to any elements
 * that are `position: sticky;` and you need to know when that element is
 * "stuck", useful for styling elements differently.
 */
export default function initStickyElementTrackers(): void {
    // Elements with the data attribute data-sticky-tracking="true"
    // are expected to be "position: sticky"
    document.querySelectorAll<HTMLElement>( '[data-sticky-tracking="true"]' ).forEach( ( element: HTMLElement ) => {
        const observer = new IntersectionObserver( ( [ entry ] ) => {
            let isSticky = false;

            // data-sticky-tracking-anchor tells us if the element
            // is sticky to the top/bottom of it's parent
            switch ( element.dataset.stickyTrackingAnchor ) {
            case 'top':
                isSticky = entry.intersectionRatio > 1;
                break;
            case 'bottom':
                isSticky = entry.intersectionRatio < 1;
                break;
            }

            // Add/remove the class so that CSS can style the element
            if ( isSticky ) {
                entry.target.classList.add( 'is-sticky' );
            } else {
                entry.target.classList.remove( 'is-sticky' );
            }
        },
        {
            threshold: [ 1 ],
        } );

        observer.observe( element );
    } );
}
